(function () {
  'use strict';

  // Guard: prevent multiple IIFE executions when the script tag is emitted more than once
  // (happens when product-item.liquid is rendered via {% render %} which has isolated Liquid scope,
  // so the unless-swym_wishlist_btn_assets_loaded guard doesn't deduplicate across card renders).
  if (window.SwymWishlistBtnInitialized) return;
  window.SwymWishlistBtnInitialized = true;

  var Core = window.SwymWishlistCore;
  if (!Core) return;

  var ACTIVE_CLASS = 'SwymWishlistBtn--active';
  var variantListenerBound = false;
  var inlineSizeGateListenerBound = false;
  var clickDelegationBound = false;
  var wishlistRevealFallbackTimer = null;
  var SWYM_READY_TIMEOUT_MS = 1200;
  var ghostAutoSyncInFlight = false;
  /** Swym list rows; used to re-apply Active/Add state when the PDP variant (size) changes. */
  var cachedWishlistItems = null;

  function dispatchWishlistUpdated() {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-updated', { bubbles: true }),
      );
    } catch (e) {
      /* ignore */
    }
  }

  function getSizeHintForButton(btn) {
    var wrap = btn.closest('.SwymWishlistBtn__Wrap');
    return wrap ? wrap.querySelector('.SwymWishlistBtn__SizeHint') : null;
  }

  function revealWishlistButtons() {
    if (wishlistRevealFallbackTimer !== null) {
      clearTimeout(wishlistRevealFallbackTimer);
      wishlistRevealFallbackTimer = null;
    }
    function forceVisible(el) {
      if (!el) return;
      try {
        el.style.setProperty('opacity', '1', 'important');
      } catch (e) {
        el.style.opacity = '1';
      }
    }
    document.querySelectorAll('.SwymWishlistBtn__Wrap').forEach(function (wrap) {
      wrap.classList.add('SwymWishlistBtn__Wrap--ready');
      forceVisible(wrap);
    });
    if (!document.querySelector('.SwymWishlistBtn__Wrap')) {
      getAllButtons().forEach(forceVisible);
    }
  }

  function scheduleWishlistRevealFallback(delayMs) {
    var d = typeof delayMs === 'number' ? delayMs : 4500;
    if (wishlistRevealFallbackTimer !== null) {
      clearTimeout(wishlistRevealFallbackTimer);
    }
    wishlistRevealFallbackTimer = setTimeout(function () {
      wishlistRevealFallbackTimer = null;
      revealWishlistButtons();
    }, d);
  }

  /**
   * Match PDP “Add to bag”: until ATC is enabled (size/options chosen), block wishlist add.
   * Saved (active) state stays clickable for remove.
   */
  function syncPdpWishlistGate() {
    document.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]').forEach(function (btn) {
      var hint = getSizeHintForButton(btn);

      function setHint(visible) {
        if (!hint) return;
        if (visible) {
          hint.classList.add('is-visible');
        } else {
          hint.classList.remove('is-visible');
        }
      }

      if (btn.classList.contains(ACTIVE_CLASS)) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var atc = form.querySelector('.ProductForm__AddToCart');
      if (!atc) {
        btn.removeAttribute('disabled');
        setHint(false);
        return;
      }

      var blocked = atc.hasAttribute('disabled');

      // For disallow_notify_me (Sold Out) products the ATC is always disabled,
      // but users should still be able to save a size. If a size radio is checked,
      // treat the gate as open so "Add to Saved" is enabled.
      if (blocked) {
        var checkedSize = form.querySelector('.InlineSizeSelector__Radio:checked');
        if (checkedSize) blocked = false;
      }

      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
      setHint(blocked);
    });
  }

  function onVariantChangedForWishlist(ev) {
    var v = ev.detail && ev.detail.variant;
    if (!v || !v.id) {
      syncPdpWishlistGate();
      return;
    }
    var root = ev.target;
    var buttons = root
      ? root.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]')
      : null;
    if (!buttons || !buttons.length) {
      buttons = document.querySelectorAll('.SwymWishlistBtn[data-swym-pdp-gate]');
    }
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('data-swym-variant-id', String(v.id));
    }
    if (cachedWishlistItems !== null) {
      applyWishlistItemsToButtons(cachedWishlistItems);
    } else {
      syncPdpWishlistGate();
    }
  }

  function onSwymReady(callback, options) {
    var called = false;
    var timeoutMs = options && typeof options.timeoutMs === 'number'
      ? options.timeoutMs
      : 0;

    function done(swat) {
      if (called) return;
      called = true;
      callback(swat || window._swat || null);
    }

    if (window._swat) {
      done(window._swat);
      return;
    }

    if (timeoutMs > 0) {
      setTimeout(function () {
        done(null);
      }, timeoutMs);
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(function (arg) {
      done(arg || window._swat || null);
    });
  }

  function getAllButtons() {
    return document.querySelectorAll('.SwymWishlistBtn');
  }

  function getWishlistLabels(btn) {
    var add = btn.getAttribute('data-wishlist-label-add');
    var remove = btn.getAttribute('data-wishlist-label-remove');
    return {
      add: add && add.length ? add : 'Add to Wishlist',
      remove: remove && remove.length ? remove : 'Saved',
    };
  }

  function getButtonData(btn) {
    var vid = btn.getAttribute('data-swym-variant-id');
    var epiNum = vid == null || vid === '' ? NaN : parseInt(vid, 10);
    return {
      empi: parseInt(btn.getAttribute('data-swym-product-id'), 10),
      epi: epiNum,
      epiStr: vid == null ? '' : String(vid),
      du: window.location.origin + btn.getAttribute('data-swym-product-url'),
    };
  }

  function productHandleFromUrl(du) {
    if (!du) return '';
    var m = String(du).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /**
   * Epi alone is not enough: Swym rows can line up with the current variant id while
   * referring to a different product (or stale du). Require empi and /products handle
   * alignment when those fields exist so one-size / default states don’t false-"Saved".
   */
  function itemMatchesPdpData(item, data) {
    if (item == null || item.epi == null || !data) return false;
    if (item.empi != null && data.empi != null) {
      var rowEmpi = Number(item.empi);
      if (!isNaN(rowEmpi) && rowEmpi !== data.empi) {
        return false;
      }
    }
    if (item.du && data.du) {
      var hItem = productHandleFromUrl(item.du);
      var hPdp = productHandleFromUrl(data.du);
      if (hItem && hPdp && hItem !== hPdp) {
        return false;
      }
    }
    return Core.wishlistEpiMatchesRow(item, data);
  }

  // ─── Ghost-Intent: cookie-less local save until the shopper consents ───
  // Mirrors Swym's default advanced-pdp-button Ghost-Intent flow (see
  // assets/swym-ghost-wishlist.js) so this custom button behaves the same way:
  // saves locally when consent hasn't been given, syncs to the real Swym
  // account once the shopper accepts.

  var GHOST_STRINGS_FALLBACK = {
    deviceTitle: 'Save to this device?',
    deviceMessage: 'This will be saved to your device only, without using cookies.',
    deviceAccept: 'Save',
    deviceDecline: 'No thanks',
    nudgeTitle: 'Sync your saved items',
    nudgeMessage: 'Allow cookies to keep this list and access it on any device.',
    nudgeAccept: 'Allow and Sync',
    nudgeDecline: 'Not now',
    confirmTitle: 'Are you sure?',
    confirmMessage: 'Without syncing, saved items may not be accessible later.',
    confirmAccept: 'Allow and Sync',
    confirmDecline: 'Continue without saving',
  };

  function ghostString(key) {
    var strings = window.swymWishlistStrings && window.swymWishlistStrings.ghostIntent;
    return (strings && strings[key]) || GHOST_STRINGS_FALLBACK[key];
  }

  function applyGhostUi(btn, isSaved) {
    var labels = getWishlistLabels(btn);
    if (isSaved) {
      btn.classList.add(ACTIVE_CLASS);
      btn.setAttribute('aria-label', labels.remove);
    } else {
      btn.classList.remove(ACTIVE_CLASS);
      btn.setAttribute('aria-label', labels.add);
    }
    var label = btn.querySelector('.SwymWishlistBtn__Label');
    if (label) label.textContent = isSaved ? labels.remove : labels.add;
  }

  function getGhostProductFromButton(btn) {
    var data = getButtonData(btn);
    return {
      empi: isNaN(data.empi) ? null : data.empi,
      epi: isNaN(data.epi) ? null : data.epi,
      du: data.du,
      dt: btn.getAttribute('data-swym-product-title') || document.title,
      iu: btn.getAttribute('data-swym-product-image') || '',
      pr: parseFloat(btn.getAttribute('data-swym-product-price')) || null,
    };
  }

  var ghostPopupEl = null;

  /** Builds (once) a centered modal — overlay + card + accept/decline — mirroring Swym's own #swym-consent-popup structure. */
  function ensureGhostPopupEl() {
    if (ghostPopupEl) return ghostPopupEl;

    var popup = document.createElement('div');
    popup.className = 'swym-ghost-popup';
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.innerHTML =
      '<div class="swym-ghost-popup-overlay" data-swym-ghost-close></div>' +
      '<div class="swym-ghost-popup-content">' +
      '<button type="button" class="swym-ghost-popup-close" data-swym-ghost-close aria-label="Close">&times;</button>' +
      '<h3 class="swym-ghost-popup-title" data-swym-ghost-title></h3>' +
      '<p class="swym-ghost-popup-message" data-swym-ghost-message></p>' +
      '<div class="swym-ghost-popup-actions">' +
      '<button type="button" class="swym-ghost-popup-btn swym-ghost-popup-btn--primary" data-swym-ghost-accept>' +
      '<span class="swym-ghost-popup-btn-text" data-swym-ghost-accept-text></span>' +
      '<span class="swym-ghost-popup-spinner" aria-hidden="true"></span>' +
      '</button>' +
      '<button type="button" class="swym-ghost-popup-btn" data-swym-ghost-decline></button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(popup);
    ghostPopupEl = popup;
    return popup;
  }

  /** Centered modal prompt (not a drawer) — same interaction as Swym's default consent popup: overlay/close dismiss with no side effect, Decline has state consequences, Accept shows a spinner until onAccept's `done` fires. */
  function showGhostPopup(kind, onAccept, onDecline) {
    var popup = ensureGhostPopupEl();
    var acceptBtn = popup.querySelector('[data-swym-ghost-accept]');
    var declineBtn = popup.querySelector('[data-swym-ghost-decline]');

    popup.querySelector('[data-swym-ghost-title]').textContent = ghostString(kind + 'Title');
    popup.querySelector('[data-swym-ghost-message]').textContent = ghostString(kind + 'Message');
    popup.querySelector('[data-swym-ghost-accept-text]').textContent = ghostString(kind + 'Accept');
    declineBtn.textContent = ghostString(kind + 'Decline');

    function hide() {
      popup.setAttribute('aria-hidden', 'true');
      acceptBtn.classList.remove('swym-ghost-loading');
    }

    Array.prototype.forEach.call(popup.querySelectorAll('[data-swym-ghost-close]'), function (el) {
      el.onclick = hide;
    });

    acceptBtn.onclick = function () {
      acceptBtn.classList.add('swym-ghost-loading');
      onAccept(hide);
    };
    declineBtn.onclick = function () {
      hide();
      if (onDecline) onDecline();
    };

    popup.setAttribute('aria-hidden', 'false');
  }

  /** Consent granted (nudge or confirm-alert accept): remember it, sync local items once swat is ready. */
  function finishGhostSync(done) {
    var Ghost = window.SwymGhostWishlist;
    Ghost.setConsentGiven();
    Ghost.resetConsentState();
    onSwymReady(
      function (swat) {
        Ghost.syncToCloud(swat, function () {
          syncButtonStates(swat);
          dispatchWishlistUpdated();
          done();
          window.location.reload();
        });
      },
      { timeoutMs: SWYM_READY_TIMEOUT_MS },
    );
  }

  function handleGhostNudgeDecline() {
    var Ghost = window.SwymGhostWishlist;
    if (Ghost.getDeclineStage() >= 1) {
      Ghost.setConsentBlocked();
    } else {
      Ghost.advanceDeclineStage();
    }
  }

  function maybeShowGhostSyncNudge() {
    var Ghost = window.SwymGhostWishlist;
    if (Ghost.shouldShowSyncNudge() !== 'popup') return;
    var kind = Ghost.getDeclineStage() >= 1 ? 'confirm' : 'nudge';
    showGhostPopup(kind, finishGhostSync, handleGhostNudgeDecline);
  }

  function handleGhostClick(btn) {
    var Ghost = window.SwymGhostWishlist;
    var product = getGhostProductFromButton(btn);

    function emitGhostCount() {
      try {
        var count = Ghost.getItems ? Ghost.getItems().length : 0;
        document.documentElement.dispatchEvent(
          new CustomEvent('swym:wishlist-count', {
            bubbles: true,
            detail: { count: count },
          }),
        );
      } catch (e) {
        /* ignore */
      }
    }

    function doLocalToggle() {
      var isNowSaved = Ghost.toggleItem(product);
      applyGhostUi(btn, isNowSaved);
      dispatchWishlistUpdated();
      emitGhostCount();
      if (isNowSaved) {
        Ghost.incrementClickCounter();
        maybeShowGhostSyncNudge();
      }
    }

    if (Ghost.requiresLocalStorageConsent()) {
      showGhostPopup(
        'device',
        function (done) {
          Ghost.setLocalConsentGiven();
          doLocalToggle();
          done();
        },
        null,
      );
      return;
    }

    if (Ghost.isConsentBlocked()) {
      showGhostPopup(
        'confirm',
        function (done) {
          Ghost.addItem(product);
          applyGhostUi(btn, true);
          dispatchWishlistUpdated();
          emitGhostCount();
          finishGhostSync(done);
        },
        handleGhostNudgeDecline,
      );
      return;
    }

    doLocalToggle();
  }

  function canAutoSyncGhostToCloud() {
    var Ghost = window.SwymGhostWishlist;
    if (!Ghost || typeof Ghost.getSyncableItems !== 'function') return false;
    var syncable = Ghost.getSyncableItems();
    if (!syncable || !syncable.length) return false;

    // Sync once shopper has granted consent or privacy processing is allowed.
    if (typeof Ghost.hasConsentBeenGiven === 'function' && Ghost.hasConsentBeenGiven()) {
      return true;
    }
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.preferencesProcessingAllowed &&
        window.Shopify.customerPrivacy.preferencesProcessingAllowed()
      ) {
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function autoSyncGhostToCloudIfPossible(swat) {
    var Ghost = window.SwymGhostWishlist;
    if (!swat || !Ghost || ghostAutoSyncInFlight) return;
    if (!canAutoSyncGhostToCloud()) return;

    ghostAutoSyncInFlight = true;
    Ghost.syncToCloud(
      swat,
      function () {
        ghostAutoSyncInFlight = false;
        syncButtonStates(swat);
      },
      { clearOnSuccess: true },
    );
  }

  // Capture phase so this always runs before the SDK-gated delegated handler
  // registered in init() below, regardless of load order.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.SwymWishlistBtn');
      if (!btn || btn.hasAttribute('disabled')) return;
      var Ghost = window.SwymGhostWishlist;
      if (!Ghost || !Ghost.isGhostIntentActive()) return;
      e.preventDefault();
      e.stopPropagation();
      handleGhostClick(btn);
    },
    true,
  );

  function applyWishlistItemsToButtons(items) {
    cachedWishlistItems = Array.isArray(items) ? items.slice(0) : [];
    getAllButtons().forEach(function (btn) {
      var labels = getWishlistLabels(btn);
      btn.classList.remove(ACTIVE_CLASS);
      btn.setAttribute('aria-label', labels.add);
      var labelEl = btn.querySelector('.SwymWishlistBtn__Label');
      if (labelEl) labelEl.textContent = labels.add;
    });

    items = items || [];
    if (items[0] && items[0].lid) {
      Core.rememberWishlistLid(items[0].lid);
    }

    getAllButtons().forEach(function (btn) {
      var data = getButtonData(btn);
      var inList = false;
      var j;
      for (j = 0; j < items.length; j++) {
        if (itemMatchesPdpData(items[j], data)) {
          inList = true;
          break;
        }
      }
      // Ghost-Intent: a locally-saved-but-not-yet-synced item won't be in the
      // real Swym `items` fetched from the account, but the button should still
      // render as Saved for this shopper/device.
      if (!inList && window.SwymGhostWishlist && window.SwymGhostWishlist.isWishlisted({ du: data.du })) {
        inList = true;
      }
      if (inList) {
        var labels = getWishlistLabels(btn);
        btn.classList.add(ACTIVE_CLASS);
        btn.setAttribute('aria-label', labels.remove);
        var label = btn.querySelector('.SwymWishlistBtn__Label');
        if (label) label.textContent = labels.remove;
      }
    });
    syncPdpWishlistGate();
    revealWishlistButtons();
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('swym:wishlist-count', {
          bubbles: true,
          detail: { count: cachedWishlistItems ? cachedWishlistItems.length : 0 },
        }),
      );
    } catch (e) { /* ignore */ }
  }

  function tryLegacyFetchWishlist(swat) {
    // Ghost-Intent: route the error path through applyWishlistItemsToButtons([])
    // too (not revealWishlistButtons() directly) - a hard Swym API failure is
    // exactly the situation where locally-saved items still need to render.
    if (
      !Core.invokeFetchWishlist(
        swat,
        applyWishlistItemsToButtons,
        function () {
          applyWishlistItemsToButtons([]);
        },
      )
    ) {
      applyWishlistItemsToButtons([]);
    }
  }

  /**
   * Match swym-wishlist.js + swym-cart-saved: items may live in any list lid; a single
   * pickWishlistList miss or response.items vs response.data.items was hiding saved state on refresh.
   */
  function fetchMergedListsOrLegacy(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') {
      tryLegacyFetchWishlist(swat);
      return;
    }
    try {
      swat.fetchLists({
        callbackFn: function (rawLists) {
          var lists = Core.normalizeFetchListsPayload(rawLists);
          if (!lists || !lists.length) {
            tryLegacyFetchWishlist(swat);
            return;
          }

          var withLid = lists.filter(function (l) {
            return l && l.lid;
          });
          if (!withLid.length) {
            tryLegacyFetchWishlist(swat);
            return;
          }

          withLid.sort(function (a, b) {
            return (
              (Core.isSaveForLaterList(a) ? 1 : 0) -
              (Core.isSaveForLaterList(b) ? 1 : 0)
            );
          });

          // Cache the wishlist lid now (from list metadata, not item rows)
          // so the fast fetchListDetails path works on subsequent loads.
          var wishlistMeta = null;
          for (var wi = 0; wi < withLid.length; wi++) {
            if (!Core.isSaveForLaterList(withLid[wi])) {
              wishlistMeta = withLid[wi];
              break;
            }
          }
          if (!wishlistMeta) wishlistMeta = withLid[0];
          if (wishlistMeta && wishlistMeta.lid) {
            Core.rememberWishlistLid(wishlistMeta.lid);
          }

          var merged = [];
          var i = 0;
          function step() {
            if (i >= withLid.length) {
              if (merged.length === 0) {
                tryLegacyFetchWishlist(swat);
                return;
              }
              applyWishlistItemsToButtons(
                Core.dedupeWishlistRowsKeepLast(merged),
              );
              return;
            }
            var meta = withLid[i++];
            swat.fetchListDetails(
              { lid: meta.lid },
              function (response) {
                merged = merged.concat(Core.extractListItems(response));
                step();
              },
              function () {
                step();
              },
            );
          }
          step();
        },
        errorFn: function () {
          tryLegacyFetchWishlist(swat);
        },
      });
    } catch (e) {
      tryLegacyFetchWishlist(swat);
    }
  }

  function syncButtonStates(swat) {
    if (!swat) {
      applyWishlistItemsToButtons([]);
      return;
    }
    if (typeof swat.fetchLists !== 'function') {
      tryLegacyFetchWishlist(swat);
      return;
    }
    var stored = Core.readStoredWishlistLid();
    if (stored && typeof swat.fetchListDetails === 'function') {
      try {
        swat.fetchListDetails(
          { lid: stored },
          function (response) {
            var items = Core.extractListItems(response);
            if (items.length > 0) {
              applyWishlistItemsToButtons(items);
              return;
            }
            fetchMergedListsOrLegacy(swat);
          },
          function () {
            fetchMergedListsOrLegacy(swat);
          },
        );
      } catch (e) {
        fetchMergedListsOrLegacy(swat);
      }
      return;
    }
    fetchMergedListsOrLegacy(swat);
  }

  function applyInactiveUi(btn) {
    var data = getButtonData(btn);
    if (cachedWishlistItems && cachedWishlistItems.length) {
      cachedWishlistItems = cachedWishlistItems.filter(function (it) {
        return !itemMatchesPdpData(it, data);
      });
    }
    var labels = getWishlistLabels(btn);
    btn.classList.remove(ACTIVE_CLASS);
    btn.setAttribute('aria-label', labels.add);
    var label = btn.querySelector('.SwymWishlistBtn__Label');
    if (label) label.textContent = labels.add;
    syncPdpWishlistGate();
  }

  function applyActiveUi(btn) {
    var data = getButtonData(btn);
    if (cachedWishlistItems === null) {
      cachedWishlistItems = [];
    }
    var already = false;
    for (var j = 0; j < cachedWishlistItems.length; j++) {
      if (itemMatchesPdpData(cachedWishlistItems[j], data)) {
        already = true;
        break;
      }
    }
    if (!already) {
      cachedWishlistItems.push({
        epi: Core.epiForSwymApi(data),
        empi: data.empi,
        du: data.du,
      });
    }
    var labels = getWishlistLabels(btn);
    btn.classList.add(ACTIVE_CLASS);
    btn.setAttribute('aria-label', labels.remove);
    var label = btn.querySelector('.SwymWishlistBtn__Label');
    if (label) label.textContent = labels.remove;
    syncPdpWishlistGate();
  }

  /** Store the wishlist lid after an add so the fast fetchListDetails path works on next load. */
  function persistWishlistLidFromSwym(swat) {
    if (!swat || typeof swat.fetchLists !== 'function') return;
    try {
      swat.fetchLists({
        callbackFn: function (rawLists) {
          var lists = Core.normalizeFetchListsPayload(rawLists);
          for (var i = 0; i < lists.length; i++) {
            if (lists[i] && lists[i].lid && !Core.isSaveForLaterList(lists[i])) {
              Core.rememberWishlistLid(lists[i].lid);
              return;
            }
          }
        },
        errorFn: function () { /* ignore */ },
      });
    } catch (e) { /* ignore */ }
  }

  /** Same list scan as mini-cart Saved “Add to bag” removal (swym-cart-saved). */
  function removeFromWishlist(swat, btn, data) {
    Core.removeVariantFromSwym(
      swat,
      data,
      function () {
        applyInactiveUi(btn);
        dispatchWishlistUpdated();
      },
      function () {
        /* silent fail */
      },
    );
  }

  function handleClick(swat, btn) {
    if (btn.disabled) {
      return;
    }

    if (!swat) {
      var Ghost = window.SwymGhostWishlist;
      if (Ghost) {
        handleGhostClick(btn);
      }
      return;
    }

    var data = getButtonData(btn);
    var isActive = btn.classList.contains(ACTIVE_CLASS);

    if (isActive) {
      removeFromWishlist(swat, btn, data);
    } else {
      swat.addToWishList(
        { epi: Core.epiForSwymApi(data), empi: data.empi, du: data.du },
        function () {
          applyActiveUi(btn);
          persistWishlistLidFromSwym(swat);
          dispatchWishlistUpdated();
        },
        function () {
          // silent fail
        },
      );
    }
  }

  function init(swat) {
    if (!variantListenerBound) {
      variantListenerBound = true;
      document.addEventListener('variant:changed', onVariantChangedForWishlist);
    }
    if (!inlineSizeGateListenerBound) {
      inlineSizeGateListenerBound = true;
      document.addEventListener(
        'change',
        function (ev) {
          var t = ev.target;
          if (!t || !t.classList || !t.classList.contains('InlineSizeSelector__Radio')) {
            return;
          }
          if (document.querySelector('.SwymWishlistBtn[data-swym-pdp-gate]')) {
            setTimeout(syncPdpWishlistGate, 0);
          }
        },
        true,
      );
    }

    scheduleWishlistRevealFallback(5000);
    autoSyncGhostToCloudIfPossible(swat);
    syncButtonStates(swat);
    syncPdpWishlistGate();
    setTimeout(syncPdpWishlistGate, 0);
    setTimeout(syncPdpWishlistGate, 450);
  }

  if (!clickDelegationBound) {
    clickDelegationBound = true;
    // Bound immediately (not inside init/onSwymReady) so a click that happens
    // while Swym's SDK is still booting isn't silently dropped - it resolves
    // swat lazily per click instead of relying on init() having already run.
    // Event delegation: one handler covers all current and future .SwymWishlistBtn elements,
    // which is essential because product cards can render after init() fires.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.SwymWishlistBtn');
      if (!btn) return;
      e.preventDefault();
      onSwymReady(
        function (swat) {
          handleClick(swat, btn);
        },
        { timeoutMs: SWYM_READY_TIMEOUT_MS },
      );
    });
  }

  init(window._swat || null);
  onSwymReady(function (swat) {
    if (!swat) return;
    autoSyncGhostToCloudIfPossible(swat);
    syncButtonStates(swat);
  });
})();
